export default {
  title: 'Ajan päivitys!',
  labels: {
    old_time: 'Edellinen noutoaika:',
    new_time: 'Uusi noutoaika:',
    old_serve_time: 'Edellinen tarjoiluaika:',
    new_serve_time: 'Uusi tarjoiluaika:',
  },
  buttons: {
    print: 'Tulosta ja sulje',
    got_it: 'Selvä',
  },
  feedback: {
    new_prep_time: 'Toimitusaikaa on päivitetty. Mukauta valmisteluaikatauluasi vastaavasti.',
  },
  toasts: {
    something_went_wrong: 'Jokin meni pieleen, yritä uudelleen',
  },
};
